import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  DropDownListComponent,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import {
  MaskedTextBoxComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { Component } from 'react';
import { BsCheck2, BsPersonCircle } from 'react-icons/bs';
import { all_information, loadingShow } from '../../../App';
import {
  addusers,
  deleteusers,
  editusers,
  forgetPassword,
  getusers,
} from '../../../services/Users/Users';
import Message from '../../../utils/Message/Message';
import './security.css';
import { BiX } from 'react-icons/bi';
import { ThemeContext } from '../../../context/theme.context';
import { getSecurityRoles } from '../../../services/SecurityRoles/SecurityRoles';
import { getAssignments } from '../../../services/assignments/assignmentService';
import {
  getCompany,
  getSites,
} from '../../../services/Company/CompanyServices';
import { FilePond, registerPlugin } from 'react-filepond';
// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import axios from 'axios';
import { FcEditImage } from 'react-icons/fc';
import { GetBackendUrlForGlobalFunctions } from '../../../App';
import { getDepartment } from '../../../services/Department/DepartmentServices';
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageEdit
);
interface IState {
  visibleAddDialog: boolean;
  visibleEditDialog: boolean;
  visibleDeleteDialog: boolean;
  visibleForgetPassDialog: boolean;
  visibleImageUploadDialog: boolean;
  companyData: any;
  siteData: any;
  departmentData: any;
  assignmentSecurityRolesData: any;
  assignmentLinkData: any;
  ApplicationUserID: string;
  userData: Array<any>;
  Company: number;
  Department: number;
  Site: number;
  AssignmetLink: number;
  nextText: string;
  isNext: boolean;
  sec_role_value: number;
  file: Array<any>;
  currentFile: Array<any>;
  current_url: string;
}
interface IProps {
  GridHeight: any;
  companyObj?: any;
  change: (val: any) => void;
  triggered: () => void;
}

export class AUM extends Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private AUMGrid: GridComponent;
  private buttonForAdd: ButtonPropsModel[];
  private buttonsDelete: ButtonPropsModel[];
  private buttonsForget: ButtonPropsModel[];
  private buttonsUpload: ButtonPropsModel[];
  private firstName: string = '';
  private lastName: string = '';
  private email: string = '';
  private confirmEmail: string = '';
  private password: string = '';
  private passwordConfirm: string = '';
  private Locale: string = '';
  private lockAccount: boolean = false;
  private status: boolean = false;
  private isAproved: boolean = false;
  private isSupport: boolean = false;
  private isAdmin: boolean = false;
  private contact_number = '';
  private activeZone: boolean = false;
  private headerText = 'Register New Application User';
  private user_id = -1;
  private allSecurityRolesData = [];
  private _isMounted = false;
  private fileElement: FilePond = new FilePond({});
  private isEdit: boolean = false;
  private current_image: string = '';
  private global_folder_url: string =
    GetBackendUrlForGlobalFunctions() + 'public/img';
  private global__url: string = GetBackendUrlForGlobalFunctions() + 'uploader';
  private current_user_id: number = -1;
  private oldPasswordInput: TextBoxComponent;
  private newPasswordInput: TextBoxComponent;
  private newConfirmPasswordInput: TextBoxComponent;
  private userDialog: DialogComponent;
  constructor(props: IProps) {
    super(props);
    this.AUMGrid = new GridComponent(props);
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteUser();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ visibleDeleteDialog: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsForget = [
      {
        click: () => {
          this.changePassword();
        },
        buttonModel: {
          content: 'Confirm',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ visibleForgetPassDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.buttonsUpload = [
      {
        click: () => {
          if (this.current_image !== '') {
            let theCurrentImage = `${this.global_folder_url}/${this.current_image}`;
            let theOldResult = this.state.currentFile[0];
            let theNewResult = [
              {
                ...theOldResult,
                source: theCurrentImage,
              },
            ];
            this.setState({
              visibleAddDialog: false,
            });
            this.getUserData();
            if (document.getElementById('profile-image')) {
              let image = document.getElementById('profile-image') as any;
              image.src = theCurrentImage;
            }
            this.setState({
              visibleImageUploadDialog: false,
              visibleAddDialog: true,
              currentFile: theNewResult,
              current_url: theCurrentImage,
            });
          } else {
            this.setState({
              visibleImageUploadDialog: false,
            });
          }
        },
        buttonModel: {
          content: 'Done',
          isPrimary: true,
        },
      },
    ];
    this.state = {
      visibleAddDialog: false,
      visibleEditDialog: false,
      assignmentLinkData: [],
      assignmentSecurityRolesData: [],
      companyData: [],
      departmentData: [],
      siteData: [],
      ApplicationUserID: '',
      userData: [],
      visibleDeleteDialog: false,
      visibleForgetPassDialog: false,
      Company: -1,
      AssignmetLink: -1,
      Department: -1,
      Site: -1,
      nextText: 'Next',
      isNext: true,
      sec_role_value: -1,
      file: [],
      visibleImageUploadDialog: false,
      currentFile: [],
      current_url: '',
    };
    this.buttonForAdd = [
      {
        click: () => {
          this.createUsers();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ visibleAddDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
          isPrimary: false,
        },
      },
    ];
    this.newConfirmPasswordInput = new TextBoxComponent({});
    this.oldPasswordInput = new TextBoxComponent({});
    this.newPasswordInput = new TextBoxComponent({});
    this.userDialog = new DialogComponent({});
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    {
      text: 'Reset Password',
      tooltipText: 'Reset Password',
      prefixIcon: 'e-password',
      id: 'forgot-pass',
      position: 'Right',
    },
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: false,
    allowEditOnDblClick: false,
    showConfirmDialog: false,
    showDeleteConfirmDialog: false,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  async getAllCompanies() {
    await getCompany()
      .then((el) => {
        this.setState({ companyData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getAllAssignment() {
    getAssignments()
      .then((el) => {
        this.setState({ assignmentLinkData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  async componentDidMount() {
    this._isMounted = true;
    this.getAllRoles();
    await this.getAllCompanies();
  }
  getUserData() {
    getusers()
      .then((el) => {
        let userData = new Array<any>();
        if (this.props.companyObj) {
          if (this.props.companyObj?.company_id !== -1) {
            userData = el.data.filter((el: any) => {
              return el.company_id === this.props.companyObj.company_id;
            });
          } else {
            userData = el.data;
          }
        } else {
          userData = el.data;
        }
        if (this._isMounted) {
          this.setState({ userData: el.data });
        }
      })
      .catch((e) => {
        //(e);
      });
  }
  beforeTimeOut(selectedElement: any) {
    this.toggleCond = true;
    this.firstName = selectedElement[0].first_name;
    this.lastName = selectedElement[0].last_name;
    this.Locale = selectedElement[0].locale;
    this.email = selectedElement[0].email;
    this.confirmEmail = selectedElement[0].email;
    this.password = '';
    this.passwordConfirm = '';
    this.activeZone = false;
    this.headerText = 'Edit User';
    this.user_id = selectedElement[0].user_id;
    this.status = selectedElement[0].status_id;
    this.lockAccount = selectedElement[0].lock_account;
    this.isAdmin = selectedElement[0].isAdmin;
    this.isAproved = selectedElement[0].isAprover;
    this.isSupport = selectedElement[0].isSupport;
    this.contact_number = selectedElement[0].contact_number;
    loadingShow(false);
    this.setState({
      ApplicationUserID: selectedElement[0].application_user_id,
      Company: selectedElement[0].company_id,
      Site: selectedElement[0].site_id,
      Department: selectedElement[0].department_id,
      AssignmetLink: selectedElement[0].assignment_id?.toString(),
      nextText: 'Next',
      isNext: true,
      visibleAddDialog: true,
    });
  }
  changePassword() {
    var selectedElement = this.AUMGrid.getSelectedRecords()[0] as any;
    loadingShow(true, 'Checking');
    if (!this.newPasswordInput.value) {
      loadingShow(false);
      Message.error('Old Password is mandatory.');
      return;
    }
    if (!this.newPasswordInput.value) {
      loadingShow(false);
      Message.error('New Password is mandatory.');
      return;
    }
    if (!this.newConfirmPasswordInput.value) {
      loadingShow(false);
      Message.error('Password confirm is mandatory.');
      return;
    }
    if (this.newConfirmPasswordInput.value !== this.newPasswordInput.value) {
      loadingShow(false);
      Message.error('Password confirm must be match.');
      return;
    }
    if (this.oldPasswordInput.value === this.newPasswordInput.value) {
      loadingShow(false);
      Message.error('Password must be different then before.');
      return;
    }
    var theObj = {
      newPassword: this.newPasswordInput.value,
      oldPassword: this.oldPasswordInput.value,
      ...selectedElement,
    };
    forgetPassword(theObj)
      .then((res) => {
        loadingShow(false);
        if (res.data) {
          if (res.data.result === 'PASSWORD_CHANGED') {
            this.setState({ visibleForgetPassDialog: false });
            Message.success('Password Changed');
          } else {
            Message.error(res.data.result);
          }
        }
      })
      .catch((e) => {
        loadingShow(false);
        Message.error('Something went wrong.');
      });
  }
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.isEdit = false;
      this.setState({
        visibleAddDialog: true,
        Company: -1,
        AssignmetLink: -1,
        Department: -1,
        Site: -1,
        ApplicationUserID: '',
        nextText: 'Next',
        isNext: true,
        sec_role_value: -1,
      });
      this.activeZone = true;
      this.toggleCond = true;
      this.headerText = 'Register New Application User';
      this.firstName = '';
      this.lastName = '';
      this.Locale = '';
      this.email = '';
      this.confirmEmail = '';

      this.isAdmin = false;
      this.isAproved = false;
      this.isSupport = false;
      this.contact_number = '';
    }
    if (args.item.id === 'delete') {
      if (this.AUMGrid.getSelectedRecords()) {
        if (this.AUMGrid.getSelectedRecords().length > 0) {
          var selectedElement = this.AUMGrid.getSelectedRecords() as any;
          this.user_id = selectedElement[0].user_id;
          this.setState({ visibleDeleteDialog: true });
        }
      }
    }
    if (args.item.id === 'forgot-pass') {
      if (this.AUMGrid.getSelectedRecords()) {
        if (this.AUMGrid.getSelectedRecords().length > 0) {
          var selectedElement = this.AUMGrid.getSelectedRecords() as any;
          this.user_id = selectedElement[0].user_id;
          this.setState({ visibleForgetPassDialog: true });
        }
      }
    }
    if (args.item.id === 'edit') {
      if (this.AUMGrid.getSelectedRecords()) {
        if (this.AUMGrid.getSelectedRecords().length > 0) {
          this.isEdit = true;
          this.getAllCompanies();
          loadingShow(true, 'Loading');
          var selectedElement = this.AUMGrid.getSelectedRecords() as any;
          this.current_image = selectedElement[0]?.img_url;
          this.current_user_id = selectedElement[0]?.user_id;
          if (this.current_image) {
            let theCurrentFile = [
              {
                name: this.current_image,
                source: `${this.global_folder_url}/${this.current_image}`,
                options: { type: 'local' },
              },
            ];
            this.setState({
              currentFile: theCurrentFile,
              current_url: theCurrentFile[0].source,
            });
          } else {
            this.setState({
              currentFile: [],
            });
          }
          let theRoles = selectedElement[0].assignment_security_roles_id;
          this.filterDataAccourdingCompany(
            selectedElement[0].company_id,
            theRoles,
            selectedElement
          );
        }
      }
    }
    if (args.item.id === 'refresh') {
      this.getUserData();
    }
    if (this.AUMGrid && args.item.id === 'gridAUM_excelexport') {
      this.AUMGrid.excelExport();
    }
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (
      prevState.departmentData !== this.state.departmentData &&
      this.activeZone
    ) {
      this.userDialog?.refresh();
    }
    if (this.props.companyObj?.allow) {
      let comId = this.props.companyObj.company_id;
      getusers()
        .then((el) => {
          const data = el.data.filter((ell: any) => {
            return ell.company_id === Number(comId);
          });
          this.setState({
            userData: data,
          });
        })
        .catch((e) => {
          //(e);
        });

      this.props.change(this.props.companyObj);
    }
  }
  createUsers() {
    if (this.state.Company === -1) {
      Message.error('Company cannot be empty');
      return;
    }
    if (this.firstName === '') {
      Message.error('Firstname cannot be empty');
      return;
    }
    if (this.lastName === '') {
      Message.error('LastName cannot be empty');
      return;
    }
    if (this.email === '') {
      Message.error('Email cannot be empty');
      return;
    }
    if (this.password === '' && this.activeZone) {
      Message.error('Password cannot be empty');
      return;
    }

    if (this.state.ApplicationUserID === '') {
      Message.error('Application User ID cannot be empty');
      return;
    }
    if (this.state.sec_role_value === -1) {
      Message.error('Security role is mandatory');
      return;
    }
    if (this.email !== this.confirmEmail) {
      Message.error('Email must be mach');
      return;
    }
    if (this.password !== this.passwordConfirm) {
      Message.error('Password must be mach');
      return;
    }

    loadingShow(true, 'Adding');
    let company_name = this.state.companyData.filter((el: any) => {
      return el.Organization_Id === this.state.Company;
    });
    let site_name = this.state.siteData.filter((el: any) => {
      return el.Organization_Id === this.state.Site;
    });
    let department_name = this.state.departmentData.filter((el: any) => {
      return el.department_id === this.state.Department;
    });
    let theObject: any = {
      password: this.password,
      status_id: this.status,
      lock_account: this.lockAccount,
      application_user_id: this.state.ApplicationUserID,
      assignment_security_roles_id: this.state.sec_role_value.toString(),
      department_id: this.state.Department,
      department_name: department_name[0]?.department_code,
      company_id: this.state.Company,
      company_name: $('#AUMCompany').val(),
      site_id: this.state.Site,
      site_name: $('#AUMSite').val(),
      assignment_id: this.state.AssignmetLink,
      assignment_name: '-',
      locale: this.Locale,
      email: this.email,
      first_name: this.firstName,
      last_name: this.lastName,
      user_id: this.user_id,
      isAdmin: this.isAdmin,
      isAprover: this.isAproved,
      isSupport: this.isSupport,
      contact_number: this.contact_number,
    };
    if (this.activeZone) {
      delete theObject.user_id;
      addusers(theObject, all_information.token)
        .then((el) => {
          loadingShow(false);
          if (el.data !== 'User created') {
            Message.error(el.data);
          } else {
            Message.success('Success');
            this.setState({ visibleAddDialog: false });
            this.getUserData();
            this.getAllCompanies();
            this.props.triggered();
          }
        })
        .catch((el) => {
          loadingShow(false, 'Adding');
          Message.error('Error: ');
        });
    } else {
      if (this.password === '') {
        delete theObject.password;
      }
      editusers(theObject, all_information.token)
        .then((el) => {
          Message.success('Success');
          this.setState({ visibleAddDialog: false });
          loadingShow(false, 'Adding');
          this.getUserData();
          this.props.triggered();
        })
        .catch((el) => {
          loadingShow(false, 'Adding');
          Message.error('Error: ');
        });
    }
  }
  deleteUser() {
    loadingShow(true, 'Deleting');
    let theObject = {
      user_id: this.user_id,
    };

    deleteusers(theObject, all_information.token)
      .then((el) => {
        Message.success('Success');
        this.setState({ visibleDeleteDialog: false });
        loadingShow(false);
        this.getUserData();
      })
      .catch((el) => {
        loadingShow(false, 'Adding');
        Message.error('Error: ');
      });
  }
  disabledTemplate(e: any) {
    return (
      <div>
        {e.status_id ? (
          <div
            style={{
              backgroundColor: '#339933',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            ACTIVE
          </div>
        ) : (
          <div
            style={{
              backgroundColor: '#C90016',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            INACTIVE
          </div>
        )}
      </div>
    );
  }
  lockTemplate(e: any) {
    return (
      <div>
        {!e.lock_account ? (
          <div
            style={{
              backgroundColor: '#339933',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            UNLOCK
          </div>
        ) : (
          <div
            style={{
              backgroundColor: '#C90016',
              width: '100%',
              height: 25,
              borderRadius: 5,
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              color: 'white',
            }}
          >
            LOCK
          </div>
        )}
      </div>
    );
  }
  nameTemplate(e: any) {
    return (
      <div>
        {e.first_name} {e.last_name}
      </div>
    );
  }
  private toggleCond = true;
  startNext() {
    var collapseElement = document.getElementById('panCol');
    collapseElement?.classList.toggle('part1End');
    this.toggleCond = !this.toggleCond;
    this.setState({
      nextText: this.toggleCond ? 'Next' : 'Previous',
      isNext: this.toggleCond,
    });
  }
  isAdminTemplate(e: any) {
    return (
      <div>
        {e.isAdmin ? (
          <div>
            <BsCheck2 size={20} color='green' />
          </div>
        ) : (
          <div>
            <BiX size={20} color='red' />
          </div>
        )}
      </div>
    );
  }
  isAproverTemplate(e: any) {
    return (
      <div>
        {e.isAprover ? (
          <div>
            <BsCheck2 size={20} color='green' />
          </div>
        ) : (
          <div>
            <BiX size={20} color='red' />
          </div>
        )}
      </div>
    );
  }
  isSupportTemplate(e: any) {
    return (
      <div>
        {e.isSupport ? (
          <div>
            <BsCheck2 size={20} color='green' />
          </div>
        ) : (
          <div>
            <BiX size={20} color='red' />
          </div>
        )}
      </div>
    );
  }
  componentWillUnmount(): void {
    this._isMounted = false;
  }
  async getAllRoles() {
    await getSecurityRoles()
      .then((el) => {
        this.allSecurityRolesData = el.data;
        this.getUserData();
      })
      .catch((e) => {
        //(e);
      });
  }
  onCompanyChang(e: any) {
    this.setState({ Company: e.value, assignmentSecurityRolesData: [] });
    this.filterDataAccourdingCompany(e.value, -1, undefined);
  }
  async filterDataAccourdingCompany(
    company_id: any,
    theRoles: any,
    selectedElement: any
  ) {
    await getSites()
      .then((el) => {
        this.setState({ siteData: el.data });
      })
      .catch((e) => {
        //(e);
      });
    await getSecurityRoles(company_id)
      .then((el) => {
        this.setState({
          assignmentSecurityRolesData: el.data,
          sec_role_value: Number(theRoles),
        });
      })
      .catch((e) => {
        //(e);
      });
    //('Company');
    await getDepartment()
      .then((el) => {
        var departmentData = el.data.filter((el: any) => {
          return el.organization_id === company_id.toString();
        });
        this.setState({ departmentData: departmentData });
      })
      .catch((e) => {
        //(e);
      });
    //('Department');

    if (selectedElement !== undefined) {
      this.beforeTimeOut(selectedElement);
    }
  }
  ModuleTemplate = (modules: any) => {
    const ids = modules?.assignment_security_roles_id?.split(',');
    var names: Array<any> = [];
    ids.map((el: any) => {
      if (el !== '') {
        const theElement = this.allSecurityRolesData.filter((com: any) => {
          return com.Role_id === Number(el);
        }) as any;
        names.push(
          theElement[0]?.ROLE_CODE === undefined ? '' : theElement[0]?.ROLE_CODE
        );
      }
    });

    return (
      <div key={Math.random() + 'AUM' + 'sub'}>
        {names.length > 0 ? (
          names.map((el) => {
            let result = el ? el : '';
            return (
              <div key={Math.random() + 'sub2'} style={{ marginTop: 10 }}>
                {result}
              </div>
            );
          })
        ) : (
          <div></div>
        )}
      </div>
    );
  };
  private profileImageContent = () => {
    return (
      <div
        className='col-md-12'
        onClick={() => this.setState({ visibleImageUploadDialog: true })}
        style={{
          height: 130,
          width: 130,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          borderColor: 'red',
          borderRadius: 100,
          alignSelf: 'center',
          marginTop: 20,
          marginBottom: 20,
          marginLeft: 30,
        }}
      >
        <div>
          {this.state.currentFile.length > 0 ? (
            <div>
              <img
                src={this.state.current_url}
                width={130}
                height={130}
                style={{ borderRadius: 100 }}
                alt='avatar'
                id='profile-image'
              />
              <FcEditImage
                size={25}
                style={{
                  position: 'absolute',
                  marginTop: 100,
                  marginLeft: 0,
                }}
                onClick={() =>
                  this.setState({
                    visibleImageUploadDialog: true,
                  })
                }
              />
            </div>
          ) : (
            <div>
              <BsPersonCircle
                style={{ position: 'relative' }}
                size={100}
                onClick={() =>
                  this.setState({
                    visibleImageUploadDialog: true,
                  })
                }
              />
              <span>Click to upload</span>
            </div>
          )}
        </div>
      </div>
    );
  };
  render() {
    return (
      <div>
        <GridComponent
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.userData}
          height={this.props.GridHeight}
          ref={(theGrid: GridComponent) => (this.AUMGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowExcelExport={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='full_name'
              headerText='Full Name'
              textAlign='Left'
              template={this.nameTemplate}
            />
            <ColumnDirective
              field='Disabled'
              headerText='Status'
              textAlign='Left'
              template={this.disabledTemplate}
            />
            <ColumnDirective
              field='email'
              headerText='Email Adress'
              textAlign='Left'
            />
            <ColumnDirective
              field='assignment_security_roles_id'
              headerText='Assigned Security Rols'
              textAlign='Left'
              template={this.ModuleTemplate}
            />
            <ColumnDirective
              field='account_locked'
              headerText='Account Locked'
              textAlign='Left'
              template={this.lockTemplate}
            />
            <ColumnDirective
              field='isAdmin'
              headerText='Admin'
              textAlign='Left'
              template={this.isAdminTemplate}
            />
            <ColumnDirective
              field='isAprover'
              headerText='Aprover'
              textAlign='Left'
              template={this.isAproverTemplate}
            />
            <ColumnDirective
              field='isSupport'
              headerText='Support'
              textAlign='Left'
              template={this.isSupportTemplate}
            />
            <ColumnDirective
              field='contact_number'
              headerText='Contact Number'
              textAlign='Left'
            />
            <ColumnDirective
              field='department_name'
              headerText='Departmmant'
              textAlign='Left'
            />
            <ColumnDirective
              field='site_name'
              headerText='Site'
              textAlign='Left'
            />
            <ColumnDirective
              field='company_name'
              headerText='Company'
              textAlign='Left'
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group,
            ]}
          />
        </GridComponent>
        {this.state.visibleAddDialog ? (
          <DialogComponent
            animationSettings={{ delay: 1, duration: 500, effect: 'FadeZoom' }}
            visible={this.state.visibleAddDialog}
            header={this.headerText}
            close={() => {
              this.setState({ visibleAddDialog: false });
            }}
            open={() => {
              this.setState({ visibleAddDialog: true });
            }}
            buttons={[
              {
                click: () => {
                  this.createUsers();
                },
                buttonModel: {
                  content: 'Save',
                  isPrimary: true,
                },
              },
              {
                click: () => {
                  this.setState({ visibleAddDialog: false });
                },
                buttonModel: {
                  content: 'Cancel',
                  isPrimary: false,
                },
              },
            ]}
            width={'600px'}
            isModal
            showCloseIcon
            ref={(ref: DialogComponent) => (this.userDialog = ref)}
            content={() => (
              <div
                id='panCol'
                className='container part1Initial'
                autoCorrect='off'
              >
                <div className='row '>
                  <div className='col-md-12'>
                    <div className='col-md-6'>
                      <div className='col-md-12'>
                        <DropDownListComponent
                          id='AUMCompany'
                          placeholder='Company'
                          floatLabelType='Auto'
                          fields={{
                            text: 'organization_code',
                            value: 'organization_id',
                          }}
                          onFocus={async () => {}}
                          dataSource={this.state.companyData}
                          value={this.state.Company}
                          onChange={this.onCompanyChang.bind(this)}
                        />
                      </div>
                      <div className='col-md-12'>
                        <TextBoxComponent
                          placeholder='Name'
                          floatLabelType='Auto'
                          value={this.firstName}
                          onChange={(el: any) => {
                            this.firstName = el.value;
                          }}
                        />
                      </div>
                      <div className='col-md-12'>
                        <TextBoxComponent
                          placeholder='Surname'
                          floatLabelType='Auto'
                          value={this.lastName}
                          onChange={(e: any) => {
                            this.lastName = e.value;
                          }}
                        />
                      </div>

                      <div className='col-md-12'>
                        <TextBoxComponent
                          placeholder='Email'
                          floatLabelType='Auto'
                          value={this.email}
                          autocomplete={'custom'}
                          onChange={(e: any) => {
                            this.email = e.value;
                            if (this.email === this.confirmEmail) {
                              this.setState({ ApplicationUserID: this.email });
                            }
                          }}
                        />
                      </div>

                      <div className='col-md-12'>
                        <TextBoxComponent
                          placeholder='Email Confirmation'
                          floatLabelType='Auto'
                          autocomplete={'custom'}
                          value={this.confirmEmail}
                          onChange={(e: any) => {
                            this.confirmEmail = e.value;
                            if (this.email === this.confirmEmail) {
                              this.setState({ ApplicationUserID: this.email });
                            }
                          }}
                        />
                      </div>

                      <div className='col-md-12'>
                        <TextBoxComponent
                          id='password'
                          placeholder='Password'
                          floatLabelType='Auto'
                          type='password'
                          value={this.password}
                          autocomplete={'custom'}
                          onChange={(e: any) => {
                            this.password = e.value;
                          }}
                        />
                      </div>

                      <div className='col-md-12'>
                        <TextBoxComponent
                          placeholder='Password Confirmation'
                          type='password'
                          floatLabelType='Auto'
                          value={this.passwordConfirm}
                          autocomplete={'custom'}
                          onChange={(e: any) => {
                            this.passwordConfirm = e.value;
                          }}
                        />
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='col-md-12'>
                        <DropDownListComponent
                          placeholder='Department'
                          floatLabelType='Auto'
                          value={this.state.Department}
                          fields={{
                            text: 'department_code',
                            value: 'department_id',
                          }}
                          dataSource={this.state.departmentData}
                          onChange={(el: any) => {
                            this.setState({ Department: el.value });
                          }}
                        />
                      </div>
                      <div className='col-md-12'>
                        <DropDownListComponent
                          id='AUMSite'
                          placeholder='Site'
                          floatLabelType='Auto'
                          dataSource={this.state.siteData}
                          fields={{
                            text: 'site_name',
                            value: 'organization_id',
                          }}
                          value={this.state.Site}
                          onChange={(el: any) => {
                            this.setState({ Site: el.value });
                          }}
                        />
                      </div>
                      <div className='col-md-12'>
                        <TextBoxComponent
                          placeholder='Application User ID'
                          floatLabelType='Auto'
                          value={this.state.ApplicationUserID}
                          onChange={(el: any) => {
                            this.setState({ ApplicationUserID: el.value });
                          }}
                        />
                      </div>
                      <div className='col-md-12'>
                        <DropDownListComponent
                          id='assignmentScroll'
                          placeholder='Assignment  Link'
                          floatLabelType='Auto'
                          dataSource={this.state.assignmentLinkData}
                          fields={{
                            text: 'alias_name',
                            value: 'assignment_id',
                          }}
                          onFocus={() => {
                            this.getAllAssignment();
                          }}
                          popupHeight={'220px'}
                          value={this.state.AssignmetLink}
                          onChange={(el: any) => {
                            this.setState({ AssignmetLink: el.value });
                          }}
                        />
                      </div>
                      <div className='col-md-12'>
                        <DropDownListComponent
                          id='roles'
                          placeholder='Assignment Security Rols'
                          floatLabelType='Auto'
                          value={this.state.sec_role_value}
                          dataSource={this.state.assignmentSecurityRolesData}
                          fields={{ text: 'role_code', value: 'role_id' }}
                          onChange={(el: any) => {
                            this.setState({
                              sec_role_value: el.value,
                            });
                          }}
                        />
                      </div>
                      <div className='col-md-12'>
                        <MaskedTextBoxComponent
                          mask='+00-000-000-0000'
                          value={this.contact_number}
                          placeholder='Contact Number'
                          floatLabelType='Always'
                          onChange={(el: any) => {
                            this.contact_number = el.value;
                          }}
                        />
                      </div>
                      <div className='col-md-12'>
                        <TextBoxComponent
                          placeholder='Locale'
                          floatLabelType='Auto'
                          value={this.Locale}
                          onChange={(e: any) => {
                            this.Locale = e.value;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-12'>
                    <div className='col-md-3' style={{ marginTop: 100 }}>
                      <div className='col-md-4'>Aprover</div>
                      <div className='col-md-8'>
                        <SwitchComponent
                          id='swichActiveOrInActive'
                          cssClass='handle-color'
                          change={(e: any) => {
                            this.isAproved = e.checked;
                          }}
                          checked={this.isAproved}
                        />
                      </div>
                    </div>
                    <div className='col-md-3' style={{ marginTop: 100 }}>
                      <div className='col-md-4'>Support</div>
                      <div className='col-md-8'>
                        <SwitchComponent
                          id='swichActiveOrInActive'
                          cssClass='handle-color'
                          change={(e: any) => {
                            this.isSupport = e.checked;
                          }}
                          checked={this.isSupport}
                        />
                      </div>
                    </div>
                    <div className='col-md-3' style={{ marginTop: 100 }}>
                      <div className='col-md-6'>
                        <span>Lock Account</span>
                      </div>
                      <div className='col-md-6'>
                        <SwitchComponent
                          change={(e: any) => {
                            this.lockAccount = e.checked;
                          }}
                          checked={this.lockAccount}
                        />
                      </div>
                    </div>
                    <div className='col-md-3' style={{ marginTop: 100 }}>
                      <div className='col-md-6'>Status</div>
                      <div className='col-md-6'>
                        <SwitchComponent
                          id='swichActiveOrInActive'
                          cssClass='handle-color'
                          change={(e: any) => {
                            this.status = e.checked;
                          }}
                          checked={this.status}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          ></DialogComponent>
        ) : null}
        {this.state.visibleDeleteDialog ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            showCloseIcon={true}
            visible={this.state.visibleDeleteDialog}
            header='Confirmation'
            width={200}
            height={'auto'}
            buttons={this.buttonsDelete}
            open={() => {
              this.setState({ visibleDeleteDialog: true });
            }}
            close={() => {
              this.setState({ visibleDeleteDialog: false });
            }}
          >
            <div className='container'>
              <div className='row'>
                <span>Are you sure?</span>
              </div>
            </div>
          </DialogComponent>
        ) : null}
        {this.state.visibleForgetPassDialog ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            showCloseIcon={true}
            visible={this.state.visibleForgetPassDialog}
            header='Reset Password'
            width={500}
            height={'auto'}
            buttons={this.buttonsForget}
            open={() => {
              this.setState({ visibleForgetPassDialog: true });
            }}
            close={() => {
              this.setState({ visibleForgetPassDialog: false });
            }}
          >
            <div className='container'>
              <div className='row'>
                <div className='col-md-12'>
                  <TextBoxComponent
                    id='password'
                    ref={(ref: TextBoxComponent) =>
                      (this.oldPasswordInput = ref)
                    }
                    placeholder='Old Password'
                    floatLabelType='Auto'
                    type='password'
                    value={this.password}
                    autocomplete={'custom'}
                  />
                </div>
                <div className='col-md-12'>
                  <TextBoxComponent
                    placeholder='New Password'
                    ref={(ref: TextBoxComponent) =>
                      (this.newPasswordInput = ref)
                    }
                    type='password'
                    floatLabelType='Auto'
                    value={this.passwordConfirm}
                    autocomplete={'custom'}
                  />
                </div>
                <div className='col-md-12'>
                  <TextBoxComponent
                    placeholder='New Password Again'
                    ref={(ref: TextBoxComponent) =>
                      (this.newConfirmPasswordInput = ref)
                    }
                    type='password'
                    floatLabelType='Auto'
                    value={this.passwordConfirm}
                    autocomplete={'custom'}
                  />
                </div>
              </div>
            </div>
          </DialogComponent>
        ) : null}
        {this.state.visibleImageUploadDialog ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            showCloseIcon={true}
            visible={this.state.visibleImageUploadDialog}
            width={450}
            height={'auto'}
            buttons={this.buttonsUpload}
            open={() => {
              this.setState({ visibleImageUploadDialog: true });
            }}
            close={() => {
              this.setState({ visibleImageUploadDialog: false });
            }}
          >
            <div className='container'>
              <div className='row'>
                <FilePond
                  ref={(file: FilePond) => (this.fileElement = file)}
                  files={this.state.currentFile}
                  allowImageExifOrientation={true}
                  allowImagePreview={true}
                  onupdatefiles={(fileItems) => {
                    this.setState({
                      currentFile: fileItems.map((fileItem) => fileItem.file),
                    });
                  }}
                  allowMultiple={false}
                  allowImageCrop={true}
                  allowImageEdit={true}
                  imageEditAllowEdit={true}
                  maxFiles={3}
                  server={{
                    url: this.global__url,
                    revert: (uniqueFileId, load, error) => {
                      error('oh my goodness');
                      axios.post(
                        `${this.global__url}/delete-file`,
                        JSON.parse(uniqueFileId)
                      );
                    },
                    process: {
                      url: `/save-file?uuid=${this.current_user_id}`,
                      onload: (res: any) => {
                        this.current_image = JSON.parse(res).id;
                        return res;
                      },
                    },
                    load: (
                      uniqueFileId,
                      load,
                      error,
                      progress,
                      abort,
                      headers
                    ) => {
                      var myRequest = new Request(uniqueFileId);
                      fetch(myRequest).then(function (response) {
                        response.blob().then(function (myBlob) {
                          load(myBlob);
                        });
                      });
                    },
                  }}
                  name='file'
                  acceptedFileTypes={['image/jpeg', 'image/png']}
                  labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                />
              </div>
            </div>
          </DialogComponent>
        ) : null}
      </div>
    );
  }
}

export default AUM;
